export const GET_RPA_CHARGE_CODES_MAPPED_START = 'GET_RPA_CHARGE_CODES_MAPPED_START';
export const GET_RPA_CHARGE_CODES_MAPPED_SUCCESS = 'GET_RPA_CHARGE_CODES_MAPPED_SUCCESS';
export const GET_RPA_CHARGE_CODES_MAPPED_FAILED = 'GET_RPA_CHARGE_CODES_MAPPED_FAILED';

export const GET_RPA_CHARGE_CODES_UNMAPPED_START = 'GET_RPA_CHARGE_CODES_UNMAPPED_START';
export const GET_RPA_CHARGE_CODES_UNMAPPED_SUCCESS = 'GET_RPA_CHARGE_CODES_UNMAPPED_SUCCESS';
export const GET_RPA_CHARGE_CODES_UNMAPPED_FAILED = 'GET_RPA_CHARGE_CODES_UNMAPPED_FAILED';

export const SET_RPA_CHARGE_MAPPED_PRODUCT_START = 'SET_RPA_CHARGE_MAPPED_PRODUCT_START';
export const SET_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS = 'SET_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS';
export const SET_RPA_CHARGE_MAPPED_PRODUCT_FAILED = 'SET_RPA_CHARGE_MAPPED_PRODUCT_FAILED';

export const UPDATE_RPA_CHARGE_MAPPED_PRODUCT_START = 'UPDATE_RPA_CHARGE_MAPPED_PRODUCT_START';
export const UPDATE_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS = 'UPDATE_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS';
export const UPDATE_RPA_CHARGE_MAPPED_PRODUCT_FAILED = 'UPDATE_RPA_CHARGE_MAPPED_PRODUCT_FAILED';

export const GET_RPA_CHARGES_BY_CUSTOMER_START = 'GET_RPA_CHARGES_BY_CUSTOMER_START';
export const GET_RPA_CHARGES_BY_CUSTOMER_SUCCESS = 'GET_RPA_CHARGES_BY_CUSTOMER_SUCCESS';
export const GET_RPA_CHARGES_BY_CUSTOMER_FAILED = 'GET_RPA_CHARGES_BY_CUSTOMER_FAILED';

export const GET_RPA_CHARGES_PATIENT_STATISTICS_START = 'GET_RPA_CHARGES_PATIENT_STATISTICS_START';
export const GET_RPA_CHARGES_PATIENT_STATISTICS_SUCCESS = 'GET_RPA_CHARGES_PATIENT_STATISTICS_SUCCESS';
export const GET_RPA_CHARGES_PATIENT_STATISTICS_FAILED = 'GET_RPA_CHARGES_PATIENT_STATISTICS_FAILED';

export const getRPAChargeCodesMappedStart = () => ({
  type: GET_RPA_CHARGE_CODES_MAPPED_START,
});

export const getRPAChargeCodesMappedSuccess = (data) => ({
  type: GET_RPA_CHARGE_CODES_MAPPED_SUCCESS,
  data
});

export const getRPAChargeCodesMappedFailed = (error) => ({
  type: GET_RPA_CHARGE_CODES_MAPPED_FAILED,
  error
});

export const getRPAChargeCodesUnmappedStart = () => ({
  type: GET_RPA_CHARGE_CODES_UNMAPPED_START,
});

export const getRPAChargeCodesUnmappedSuccess = (data) => ({
  type: GET_RPA_CHARGE_CODES_UNMAPPED_SUCCESS,
  data
});

export const getRPAChargeCodesUnmappedFailed = (error) => ({
  type: GET_RPA_CHARGE_CODES_UNMAPPED_FAILED,
  error
});

export const setRPAChargeMappedProductStart = () => ({
  type: SET_RPA_CHARGE_MAPPED_PRODUCT_START,
});

export const setRPAChargeMappedProductSuccess = (data) => ({
  type: SET_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS,
  data
});

export const setRPAChargeMappedProductFailed = (error) => ({
  type: SET_RPA_CHARGE_MAPPED_PRODUCT_FAILED,
  error
});

export const updateRPAChargeMappedProductStart = () => ({
  type: UPDATE_RPA_CHARGE_MAPPED_PRODUCT_START,
});

export const updateRPAChargeMappedProductSuccess = (data) => ({
  type: UPDATE_RPA_CHARGE_MAPPED_PRODUCT_SUCCESS,
  data
});

export const updateRPAChargeMappedProductFailed = (error) => ({
  type: UPDATE_RPA_CHARGE_MAPPED_PRODUCT_FAILED,
  error
});

export const getRPAChargesByCustomerStart = () => ({
  type: GET_RPA_CHARGES_BY_CUSTOMER_START,
});

export const getRPAChargesByCustomerSuccess = (data) => ({
  type: GET_RPA_CHARGES_BY_CUSTOMER_SUCCESS,
  data
});

export const getRPAChargesByCustomerFailed = (error) => ({
  type: GET_RPA_CHARGES_BY_CUSTOMER_FAILED,
  error
});

export const getRPAChargesPatientStatisticsStart = () => ({
  type: GET_RPA_CHARGES_PATIENT_STATISTICS_START,
});

export const getRPAChargesPatientStatisticsSuccess = (data) => ({
  type: GET_RPA_CHARGES_PATIENT_STATISTICS_SUCCESS,
  data
});

export const getRPAChargesPatientStatisticsFailed = (error) => ({
  type: GET_RPA_CHARGES_PATIENT_STATISTICS_FAILED,
  error
});

